import React from 'react';
import { PlusIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
// 16 — FAQ · [SEO/GEO] [AEO] [Trust] [Conversion]
// Semantic details/summary. 12 concise, legally reviewable FAQs.
// faqs{question,answer}
const faqs = [{
  question: 'How do I know whether I have a personal injury claim?',
  answer: 'You may have a claim if someone else contributed to an injury that caused you loss — such as medical costs, time off work or ongoing effects. Eligibility depends on the facts, the timing and the law that applies.'
}, {
  question: 'What should I do immediately after an injury?',
  answer: 'Prioritise your health and seek medical care. Keep any records, note what happened and, where relevant, report the incident. Getting early advice can help preserve evidence.'
}, {
  question: 'How much does an initial discussion cost?',
  answer: 'The cost (if any) of your first confidential discussion is confirmed before you speak with us.'
}, {
  question: 'Do you offer no win, no fee arrangements?',
  answer: 'Whether a no-win-no-fee arrangement is available, and its exact conditions, is explained clearly in writing before you engage us.'
}, {
  question: 'What information should I have before calling?',
  answer: 'You do not need documents or legal terms to make the first call. Just tell us what you remember about what happened.'
}, {
  question: 'How long does a compensation claim take?',
  answer: 'This varies widely depending on the injury, the evidence and whether the matter resolves by negotiation or litigation. We give realistic guidance based on your circumstances.'
}, {
  question: 'Will my claim have to go to court?',
  answer: 'Many claims resolve without a trial. Where litigation is required to protect your interests, we are experienced in taking that step.'
}, {
  question: 'Can I claim if I was partly at fault?',
  answer: 'You may still be able to claim even if you were partly at fault, though this can affect the outcome. This depends on the facts and the applicable law.'
}, {
  question: 'Can I change personal injury lawyers?',
  answer: 'In many cases you can change lawyers during a claim. We can explain what that would involve in your situation.'
}, {
  question: 'What time limits apply?',
  answer: 'Time limits can apply to injury claims and vary by claim type. Getting advice early helps clarify the limits relevant to you.'
}, {
  question: 'Can you help if I live outside Perth?',
  answer: 'We assist injured people across Western Australia. Phone, video, home and hospital appointments may be available depending on your circumstances.'
}, {
  question: 'What happens after I submit the form?',
  answer: 'We review what you have told us and arrange a confidential conversation about your situation and next steps.'
}];
export function FAQSection() {
  return <Section id="faq" className="bg-canvas" data-id="element-103">
      <SectionHeading eyebrow="Questions & answers" title="Common Questions" intro="Plain answers to what people ask most. This is general information, not legal advice." data-id="element-104" />

      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-105">
        {faqs.map(f => <details key={f.question} className="group overflow-hidden rounded-card border border-ink/5 bg-paper shadow-card" data-id="element-106">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-6 py-5 text-body-lg font-medium text-ink marker:hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal" data-id="element-107">
              {f.question}
              <PlusIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-signal transition-transform group-open:rotate-45" strokeWidth={1.75} data-id="element-108" />
            </summary>
            <p className="px-6 pb-6 pr-10 text-body text-slate" data-id="element-109">{f.answer}</p>
          </details>)}
      </div>
    </Section>;
}